
import { Vue, Component, Prop,Watch } from "vue-property-decorator";
import { BaseVue } from "@newview/base-web";
import { ShareroadtoinstitutionApi } from '@newview/basic-api'
import { AuthApi , ModuleinforApi,ProjectInforApi} from "@newview/system-api";
import { LoginforApi } from "@newview/basicdata-api";
@Component({
  name: "Root",
  components: {
  },
})
export default class RootClass extends BaseVue {
  @Prop({ default: "/MainManage" }) defaultPagePath!: any; //默认跳转路由path
  @Prop({ default: false }) customJump!: boolean; //是否自定义登录成功跳转事件
//#region 接口定义区
shareroadtoinstitutionApi: ShareroadtoinstitutionApi = new ShareroadtoinstitutionApi();
projectInforApi:ProjectInforApi = new ProjectInforApi();
loginforApi: LoginforApi = new LoginforApi();
//#endregion 接口定义区


//#region 变量定义区

//#endregion 变量定义区


//#region 事件定义区
  created(){
    this.loginSuccess()
  }
  mounted() {
  }

  async loginSuccess() {
    const resStr:any = sessionStorage.getItem("loginResult");
    const res = JSON.parse(resStr);
    // if (res.result.UserInfo.ExpiredDate) {
    //   let flag: any = new Date(res.result.UserInfo.ExpiredDate) > new Date();
    //   if (flag == false) {
    //     this.warning("当前账号已过期！！！");
    //     return;
    //   }
    // }
    // this.saveLoginGlobalData(res)  // 保存全局变量数据

    // region JavaStart
    sessionStorage.setItem("token", res.data.token);
    sessionStorage.setItem("localUser", JSON.stringify(res.data.userInfo));
    let allList:any = res.data.userInfo.projectdataList
    this.$globalData_Plms.itemInfo = allList[0]
    this.$globalData_Plms.institutioninfor =allList[0].institutioninforList[0]; 
    this.$globalData_Plms.roleInfo =allList[0].institutioninforList[0].subsysteminforList[0].RoleInfo;
    let res1: any = await this.shareroadtoinstitutionApi.getRoadInfor(
        this.$globalData_Plms.institutioninfor.id
    )
    if (res1.code == 200) {
      this.$globalData_Plms.roadList = res1.data;
      this.$globalData_Plms.roadInfo = res1.data[0];
    }
    this.$globalData_Plms.subSysteminfor = allList[0].institutioninforList[0].subsysteminforList[0]
    this.$globalData_Plms.localUser = res.data.userInfo;
    sessionStorage.setItem(
      'globalData_Plms',
      JSON.stringify(this.$globalData_Plms)
    )
    this.$globalData_Plms.localUser = res.data.userInfo;
    sessionStorage.setItem(
      "globalData_Plms",
      JSON.stringify(this.$globalData_Plms)
    );
    // 登录成功之后查询项目的文件上传大小
    this.projectInforApi.getEntity(res.data.userInfo.projectId).then(res=>{
      if(res.code==200){
        localStorage.setItem("fileMaxFileSize", res.data.fileMaxFileSize);
      }
    })
    localStorage.setItem("MainMenuDatas",JSON.stringify(this.loadMenuList(this.$globalData_Plms.subSysteminfor.moduleinforList)));

    let subSysteminfor:any = this.$globalData_Plms.subSysteminfor
    if(!this.isNull(subSysteminfor.RoleInfo.defaultUrl)){
      this.$router.push(subSysteminfor.RoleInfo.defaultUrl); // 默认跳转路由
    }else{
      this.$router.push(this.defaultPagePath); // 默认跳转路由
    }
    //记录登录日志
    this.loginforApi.save({content:res.data.userInfo.userTrueName, actionUrl:'auth/login',logType:1,createId:res.data.userInfo.id});
    // Endregion JavaEnd
    




    // // 配置自定义跳转
    // if (this.customJump) {
    //   this.$emit("GlobalDataSuccess", res.result);
    //   return;
    // }
    // let menuList: any = res.result.MenuItems;
    // localStorage.setItem("MainMenuDatas", JSON.stringify(menuList));
    // let cary: any = this.Baselinq.from(<any[]>res.result.RoleInfos)
    //   .groupBy((e) => e.SubSystemId)
    //   .select((x) => ({ name: x.key(), value: x.getSource() }))
    //   .toArray();
    // if (cary.length > 1) {
    //   this.$router.push({
    //     path: "/SysRoleSelect",
    //     query: {
    //       defaultPagePath: this.base64encode(this.defaultPagePath),
    //     },
    //   });
    // } else {
    //   let menuList: any = res.result.MenuItems;
    //   localStorage.setItem("MainMenuDatas", JSON.stringify(menuList));
    //   localStorage.setItem("activeMenu", ""); //默认选中状态
    //   localStorage.setItem("openMenu", ""); // 默认展开菜单
    //   if (
    //     this.$globalData.roleInfo?.DefaultUrl &&
    //     this.$globalData.roleInfo?.DefaultUrl.length > 1
    //   ) {
    //     let pathName = this.$globalData.roleInfo?.DefaultUrl;
    //     pathName =
    //       pathName.indexOf("/") == 0
    //         ? pathName.substr(1, pathName.length)
    //         : pathName;
    //     this.$router.push({
    //       name: pathName,
    //     });
    //   } else {
    //     this.$router.push(this.defaultPagePath); // 默认跳转路由
    //   }
    // }
  }

  loadMenuList(datas) {
    const treeDatas: any = this.Baselinq.from(datas)
      .where((x) => x['pid'] == 0)
      .orderBy((p) => p['orderNo'])
      .toArray()
    for (let data of treeDatas) {
      data.children = this.loadMenuChild(data.id, datas)
    }
    return treeDatas
  }

  loadMenuChild(pid, datas) {
    const childDatas: any = this.Baselinq.from(datas)
      .where((x) => x['pid'] == pid)
      .orderBy((p) => p['orderNo'])
      .toArray()
    if (childDatas.length > 0) {
      for (let data of childDatas) {
        data.children = this.loadMenuChild(data.id, datas)
      }
    }
    return childDatas
  }
//#endregion 事件定义区


//#region 方法定义区

//#endregion 方法定义区
}
